import { algoliaQueryStringArrayFilter } from './algoliaQueryStringArrayFilter';
import { algoliaQueryStringFilter } from './algoliaQueryStringFilter';

export function algoliaBuildFilterString(
  filters: Record<string, string[] | string>,
): string {
  const validFilters = Object.entries(filters).filter(([_, value]) =>
    Array.isArray(value) ? value.length > 0 : value !== undefined,
  );

  const filterStrings = validFilters.map(([facet, value]) => {
    if (Array.isArray(value)) {
      return algoliaQueryStringArrayFilter(facet, value);
    }
    return algoliaQueryStringFilter(facet, value);
  });

  return filterStrings.join(' AND ');
}
